class PolyfillService {
    initializePolyfill(domain: any) {
        const polyfillScripts = [`${domain}/main.js`, `${domain}/polyfills.js`];

        polyfillScripts.forEach((path) => {
            const script = document.createElement("script");
            script.src = path;
            script.async = true;
            document.body.appendChild(script);
        });

        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${domain}/styles.css`;
        document.head.appendChild(link);
    }
}

const polyfill = new PolyfillService();

export default polyfill;